"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _statefulRadiogroupContainer = _interopRequireDefault(require("./stateful-radiogroup-container"));
var _radiogroup = _interopRequireDefault(require("./radiogroup"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

// eslint-disable-next-line import/no-named-default

// eslint-disable-next-line import/no-named-default

// Styled elements

const StatefulRadioGroup = function (props) {
  const {
    children,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(_statefulRadiogroupContainer.default, restProps, childrenProps => /*#__PURE__*/React.createElement(_radiogroup.default, childrenProps, children));
};
StatefulRadioGroup.displayName = 'StatefulRadioGroup';
var _default = exports.default = StatefulRadioGroup;